// extracted by css-extract-rspack-plugin
export default {"grantProgramCard":"GrantProgramCard_grantProgramCard__eWgLr","logoWrapper":"GrantProgramCard_logoWrapper__dtEOP"};